





















































































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';
const userModule = namespace('user');

import axios from 'axios';

@Component({
    components: {},
})
export default class PassportLayout extends Vue {

    private loginForm: any = null;

    private loading: boolean = false;

    private error: string = '';

    private loginModel: any = {
        username: null,
        password: null,
    };

    constructor() {
        super();
    }

    private mounted() {
    }

    private getRedirect() {
        return this.$route.query.redirect;
    }

    @userModule.Mutation('loginSuccess')
    private loginSuccess(param: any) {

    }

    private handleLoginSubmit(e: any) {
        e.preventDefault();
        this.loginForm.validateFields((err: any, values: any) => {
            if (!err) {
                this.loading = true;
                axios.post('/login', this.loginModel).then( (res: any) => {
                    const resData = res.data;
                    if ( resData.error) {
                        this.error = resData.error;
                        return;
                    }
                    this.loginSuccess({token: resData.token});
                    this.$ls.set('token', resData.token);
                    const redirect = this.getRedirect();
                    if (redirect != null) {
                        this.$router.push(redirect);
                    } else {
                        this.$router.push('/');
                    }
                })
                .finally(() =>  {
                    this.loading = false;
                });
            }
        });
    }

}
